import {
  FaUniversity,
  FaPiggyBank,
  FaWallet,
  FaCreditCard,
  FaChartLine,
  FaEllipsisH,
  FaUtensils,
  FaCar,
  FaHeartbeat,
  FaHome,
  FaHouseUser,
  FaGift,
  FaGraduationCap,
  FaFilm,
  FaMoneyBillWave,
  FaShoppingCart,
  FaPhone,
  FaPaw,
  FaCalculator,
  FaCalendar,
  FaHotel,
  FaMedkit,
  FaSchool,
  FaRecycle,
  FaFileAlt,
  FaShapes,
  FaCamera,
  FaAirFreshener,
  FaGifts,
  FaPalette,
  FaFire,
  FaMusic,
  FaBook,
  FaGamepad,
  FaPhoneAlt,
  FaLaptop,
  FaWifi,
  FaWater,
  FaFlask,
  FaCode,
  FaBriefcase,
  FaTrain,
  FaHeadset,
  FaStar,
  FaLeaf,
  FaGlobe,
  FaBaby,
  FaDumbbell,
  FaUmbrella,
  FaTools,
  FaTshirt,
  FaCoffee,
  FaPizzaSlice,
  FaBeer,
  FaPlane,
  FaBus,
  FaBicycle,
  FaMotorcycle,
  FaShip,
  FaSubway,
  FaTaxi,
  FaParking,
  FaGasPump,
  FaWrench,
  FaKey,
  FaLock,
  FaShieldAlt,
  FaHandHoldingUsd,
  FaCoins,
  FaDollarSign,
  FaPercent,
  FaReceipt,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaChartBar,
  FaChartPie,
  FaTrophy,
  FaMedal,
  FaAward,
  FaCrown,
  FaHeart,
  FaSmile,
  FaSadTear,
  FaAngry,
  FaSurprise,
  FaLaughBeam,
} from 'react-icons/fa';

/** Mapa de todos os ícones disponíveis por nome (suporta nomes FaXxx e nomes curtos) */
export const ICONS_MAP = {
  // Nomes completos (FaXxx)
  FaUniversity,
  FaPiggyBank,
  FaWallet,
  FaCreditCard,
  FaChartLine,
  FaEllipsisH,
  FaUtensils,
  FaCar,
  FaHeartbeat,
  FaHome,
  FaHouseUser,
  FaGift,
  FaGraduationCap,
  FaFilm,
  FaMoneyBillWave,
  FaShoppingCart,
  FaPhone,
  FaPaw,
  FaCalculator,
  FaCalendar,
  FaHotel,
  FaMedkit,
  FaSchool,
  FaRecycle,
  FaFileAlt,
  FaShapes,
  FaCamera,
  FaAirFreshener,
  FaGifts,
  FaPalette,
  FaFire,
  FaMusic,
  FaBook,
  FaGamepad,
  FaPhoneAlt,
  FaLaptop,
  FaWifi,
  FaWater,
  FaFlask,
  FaCode,
  FaBriefcase,
  FaTrain,
  FaHeadset,
  FaStar,
  FaLeaf,
  FaGlobe,
  FaBaby,
  FaDumbbell,
  FaUmbrella,
  FaTools,
  FaTshirt,
  FaCoffee,
  FaPizzaSlice,
  FaBeer,
  FaPlane,
  FaBus,
  FaBicycle,
  FaMotorcycle,
  FaShip,
  FaSubway,
  FaTaxi,
  FaParking,
  FaGasPump,
  FaWrench,
  FaKey,
  FaLock,
  FaShieldAlt,
  FaHandHoldingUsd,
  FaCoins,
  FaDollarSign,
  FaPercent,
  FaReceipt,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaChartBar,
  FaChartPie,
  FaTrophy,
  FaMedal,
  FaAward,
  FaCrown,
  FaHeart,
  FaSmile,
  FaSadTear,
  FaAngry,
  FaSurprise,
  FaLaughBeam,
  
  // Nomes curtos (usados em Categorias.js)
  'ellipsis': FaEllipsisH,
  'ellipsis-horizontal': FaEllipsisH,
  'cart': FaShoppingCart,
  'car': FaCar,
  'hotel': FaHotel,
  'home': FaHome,
  'school': FaSchool,
  'recycle': FaRecycle,
  'file': FaFileAlt,
  'shapes': FaShapes,
  'camera': FaCamera,
  'air': FaAirFreshener,
  'gift': FaGift,
  'palette': FaPalette,
  'fire': FaFire,
  'music': FaMusic,
  'book': FaBook,
  'gamepad': FaGamepad,
  'phone': FaPhone,
  'laptop': FaLaptop,
  'wifi': FaWifi,
  'water': FaWater,
  'flask': FaFlask,
  'code': FaCode,
  'briefcase': FaBriefcase,
  'train': FaTrain,
  'headset': FaHeadset,
  'star': FaStar,
  'leaf': FaLeaf,
  'globe': FaGlobe,
  'chart': FaChartLine,
  'utensils': FaUtensils,
  'heartbeat': FaHeartbeat,
  'graduation': FaGraduationCap,
  'film': FaFilm,
  'money': FaMoneyBillWave,
  'paw': FaPaw,
  'calculator': FaCalculator,
  'calendar': FaCalendar,
  'medkit': FaMedkit,
  'baby': FaBaby,
  'dumbbell': FaDumbbell,
  'umbrella': FaUmbrella,
  'tools': FaTools,
  'tshirt': FaTshirt,
  'coffee': FaCoffee,
  'pizza': FaPizzaSlice,
  'beer': FaBeer,
  'plane': FaPlane,
  'bus': FaBus,
  'bicycle': FaBicycle,
  'motorcycle': FaMotorcycle,
  'ship': FaShip,
  'subway': FaSubway,
  'taxi': FaTaxi,
  'parking': FaParking,
  'gas': FaGasPump,
  'wrench': FaWrench,
  'key': FaKey,
  'lock': FaLock,
  'shield': FaShieldAlt,
  'coins': FaCoins,
  'dollar': FaDollarSign,
  'percent': FaPercent,
  'receipt': FaReceipt,
  'invoice': FaFileInvoice,
  'trophy': FaTrophy,
  'medal': FaMedal,
  'award': FaAward,
  'crown': FaCrown,
  'heart': FaHeart,
  'smile': FaSmile,
  'telephone': FaPhone,
};

/** Retorna o componente de ícone pelo nome (string) */
export function getIconComponentByName(iconName) {
  return ICONS_MAP[iconName] || FaEllipsisH;
}

/** Ícone padrão quando o tipo não está mapeado */
export const DEFAULT_ICON = FaEllipsisH;

/** Mapeamento tipo de conta → ícone */
export const ICONS_CONTA = {
  'Conta Corrente': FaUniversity,
  'Conta Poupança': FaPiggyBank,
  Carteira: FaWallet,
  'Cartão de Crédito': FaCreditCard,
  Investimentos: FaChartLine,
  Outros: FaEllipsisH,
};

/** Mapeamento tipo de despesa/orçamento → ícone (unificado) */
export const ICONS_DESPESA = {
  Alimentação: FaUtensils,
  Transporte: FaCar,
  Saúde: FaHeartbeat,
  Moradia: FaHome,
  Aluguel: FaHouseUser,
  Outros: FaEllipsisH,
  Veículos: FaCar,
  Poupança: FaPiggyBank,
  Investimento: FaChartLine,
  'Investimentos': FaChartLine, // mesmo ícone que Investimento
  Educação: FaGraduationCap,
  Lazer: FaFilm,
  Presentes: FaGift,
  Telefonia: FaPhone,
  'Pet Shop': FaPaw,
  Vestuário: FaTshirt,
  Assinaturas: FaCalendar,
  Compras: FaShoppingCart,
  'Cartão de Crédito': FaCreditCard,
  Impostos: FaFileInvoice,
  Seguros: FaShieldAlt,
  Doações: FaHandHoldingUsd,
};

/** Mapeamento tipo de receita → ícone */
export const ICONS_RECEITA = {
  Salário: FaMoneyBillWave,
  Venda: FaShoppingCart,
  Presente: FaGift,
  Investimento: FaChartLine,
  Aluguel: FaHouseUser,
  Outros: FaEllipsisH,
};

/** Cores padrão por tipo de despesa */
export const CORES_DESPESA = {
  Alimentação: '#F97316',
  Transporte: '#3B82F6',
  Saúde: '#EF4444',
  Moradia: '#8B5CF6',
  Aluguel: '#7C3AED',
  Outros: '#6B7280',
  Veículos: '#0EA5E9',
  Poupança: '#10B981',
  Investimento: '#059669',
  Investimentos: '#059669',
  Educação: '#6366F1',
  Lazer: '#EC4899',
  Presentes: '#F43F5E',
  Telefonia: '#14B8A6',
  'Pet Shop': '#A855F7',
  Vestuário: '#D946EF',
  Assinaturas: '#06B6D4',
  Compras: '#F59E0B',
  'Cartão de Crédito': '#DC2626',
  Impostos: '#64748B',
  Seguros: '#2563EB',
  Doações: '#22C55E',
};

/** Cores padrão por tipo de receita */
export const CORES_RECEITA = {
  Salário: '#059669',
  Venda: '#F59E0B',
  Presente: '#EC4899',
  Investimento: '#2563EB',
  Aluguel: '#8B5CF6',
  Outros: '#6B7280',
};

/** Retorna o componente de ícone para um tipo (conta, despesa ou receita) */
export function getIconForTipo(tipo, categoria = 'despesa') {
  const map = categoria === 'conta' ? ICONS_CONTA : categoria === 'receita' ? ICONS_RECEITA : ICONS_DESPESA;
  return map[tipo] || DEFAULT_ICON;
}

/** Retorna a cor do ícone/categoria */
export function getColorForTipo(tipo, categoria = 'despesa', coresCustom = {}) {
  if (coresCustom && coresCustom[tipo]) return coresCustom[tipo];
  const map = categoria === 'receita' ? CORES_RECEITA : CORES_DESPESA;
  return map[tipo] || '#6B7280';
}
